import React from 'react'
import { Page, Text, Font, View, Document, StyleSheet, Image, Svg } from '@react-pdf/renderer';
import Header from './Header';
import JobDescription from './JobDescription';
import QualityControlSummary from './QualityControlSummary';
import ModelSummary from './ModelSummary';
import MainSummary from './MainSummary';

import RalewayRegular from '../../../assets/fonts/Raleway-Regular.ttf';
import RalewayRegularItalic from '../../../assets/fonts/Raleway-Italic.ttf';
import RalewayBold from '../../../assets/fonts/Raleway-Bold.ttf';
import RalewayExtraBold from '../../../assets/fonts/Raleway-ExtraBold.ttf';
import DetailPage from './DetailPage';


const Pdf = ({ data }) => {
    // console.log("PDF Data: ", data);

    Font.register({
        family: 'Raleway',
        fonts: [
            { src: RalewayRegular, fontWeight: '400' },
            { src: RalewayRegularItalic, fontWeight: '400', fontStyle: "italic" },
            { src: RalewayBold, fontWeight: '700' },
            { src: RalewayExtraBold, fontWeight: '800' },
        ],
    });
    // Font.registerHyphenationCallback((word) => {
    //     return word.split('');
    //   });


    const styles = StyleSheet.create({
        page: {
            backgroundColor: '#fff',
            padding: "20px 15px",
            width: "100%",
            fontFamily: "Raleway",
            fontWeight: "400"
        }
    });



    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Header */}
                <Header data={data} />
                {/* Header */}
                <JobDescription data={data} />

                <QualityControlSummary data={data} />
                <ModelSummary data={data} />
                <MainSummary data={data} />
            </Page>

            {
                data.orders.map((item, index) => {
                    return (
                        <Page key={index} size="A4" style={styles.page}>
                            <DetailPage order={item} data={data} />
                        </Page>
                    )
                })
            }

        </Document>
    )
}

export default Pdf